var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9846 10.2137L20.4442 5.32951L14.9846 0.445312L13.6121 1.9795L16.2063 4.30026H5.52017V6.35877H16.2063L13.6121 8.67953L14.9846 10.2137ZM6.34827 18.4478L0.888672 13.5636L6.34827 8.67937L7.72077 10.2136L5.12661 12.5343H15.8127V14.5928H5.12661L7.72077 16.9136L6.34827 18.4478Z",
    fill: "var(--secondary-4)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapOutlined);
export default __webpack_public_path__ + "static/media/swapOutlined.9fd68cf06033f42f3562d1dab6668ce2.svg";
export { ForwardRef as ReactComponent };